var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplePayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.445 31.287 c -1.055 1.248 -2.743 2.233 -4.43 2.092 c -0.211 -1.688 0.615 -3.481 1.582 -4.588 c 1.055 -1.283 2.901 -2.198 4.395 -2.268 C 18.168 28.281 17.482 30.004 16.445 31.287 M 17.974 33.714 c -2.444 -0.141 -4.536 1.389 -5.696 1.389 c -1.178 0 -2.953 -1.319 -4.887 -1.283 c -2.514 0.035 -4.852 1.459 -6.135 3.727 c -2.637 4.536 -0.686 11.251 1.863 14.943 c 1.248 1.828 2.743 3.832 4.711 3.762 c 1.863 -0.07 2.602 -1.213 4.852 -1.213 c 2.268 0 2.918 1.213 4.887 1.178 c 2.039 -0.035 3.323 -1.828 4.571 -3.657 c 1.424 -2.074 2.004 -4.096 2.039 -4.202 c -0.035 -0.035 -3.938 -1.529 -3.973 -6.03 c -0.035 -3.762 3.077 -5.555 3.217 -5.661 C 21.666 34.065 18.923 33.784 17.974 33.714 M 32.091 28.615 v 27.407 h 4.254 v -9.37 h 5.889 c 5.38 0 9.159 -3.692 9.159 -9.036 s -3.709 -9.001 -9.019 -9.001 L 32.091 28.615 L 32.091 28.615 z M 36.345 32.202 h 4.905 c 3.692 0 5.801 1.969 5.801 5.432 s -2.11 5.45 -5.819 5.45 h -4.887 V 32.202 z M 59.164 56.234 c 2.672 0 5.151 -1.354 6.276 -3.498 h 0.088 v 3.287 h 3.938 V 42.381 c 0 -3.956 -3.164 -6.505 -8.034 -6.505 c -4.518 0 -7.858 2.584 -7.981 6.135 h 3.832 c 0.316 -1.688 1.881 -2.795 4.026 -2.795 c 2.602 0 4.061 1.213 4.061 3.446 v 1.512 l -5.309 0.316 c -4.94 0.299 -7.612 2.321 -7.612 5.837 C 52.449 53.878 55.209 56.234 59.164 56.234 z M 60.307 52.981 c -2.268 0 -3.709 -1.09 -3.709 -2.76 c 0 -1.723 1.389 -2.725 4.043 -2.883 l 4.729 -0.299 v 1.547 C 65.37 51.153 63.19 52.981 60.307 52.981 z M 74.723 63.477 c 4.149 0 6.1 -1.582 7.806 -6.382 L 90 36.14 h -4.325 l -5.01 16.191 h -0.088 l -5.01 -16.191 h -4.448 l 7.208 19.953 l -0.387 1.213 c -0.65 2.057 -1.705 2.848 -3.586 2.848 c -0.334 0 -0.984 -0.035 -1.248 -0.07 v 3.287 C 73.352 63.442 74.406 63.477 74.723 63.477 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePayLogo);
export default __webpack_public_path__ + "static/media/apple-pay-logo.0bff8591c63ede59ee7dd80631910575.svg";
export { ForwardRef as ReactComponent };